module.exports = __webpack_public_path__ + "static/img/traffic.5cbda5a6.png";